export default __webpack_public_path__ + "static/media/transform-lifes-6-colombia.d60949bd.png";